import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { PostHogProvider } from 'posthog-js/react';
import App from './App.tsx';
import reportWebVitals from './reportWebVitals';
import { ErrorState } from './components/Layout/ErrorState.tsx';
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root'));


const ErrorFallback = ({ error, resetErrorBoundary }) => (
  <div className="app-error-state-fullscreen">
    <ErrorState
      eyebrow="Application error"
      title="StudyBuddy hit an unexpected problem"
      message="Refresh the app to start cleanly, or return home if this happened while opening a specific page."
      primaryAction={{ label: 'Refresh app', onClick: () => window.location.reload() }}
      secondaryAction={{ label: 'Return home', onClick: () => { resetErrorBoundary(); window.location.href = '/'; } }}
      error={error}
    />
  </div>
);

root.render(
  <React.StrictMode>
    <ErrorBoundary fallbackRender={ErrorFallback}>
      <PostHogProvider
        apiKey={process.env.REACT_APP_POSTHOG_KEY}
        options={{
          api_host: process.env.REACT_APP_POSTHOG_HOST,
          ui_host: 'https://us.posthog.com',
          defaults: '2025-05-24',
          capture_exceptions: true,
          debug: process.env.NODE_ENV === "development",
        }}
      >
        <App />
      </PostHogProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
